import { Component } from '@angular/core';

@Component({
    selector: 'ui-textarea-docs-preview',
    templateUrl: './textarea.docs.preview.html',
    styleUrls: ['./textarea.docs.preview.scss'],
})
export class UITextareaDocsPreview { }
